import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Autocomplete, Chip, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

export interface OptionType {
  label: string;
  value: string;
  count?: number;
}

interface Props {
  value: string;
  values?: string[];
  placeholder?: string;
  label?: string;
  disableBorder?: boolean;

  onChange(event: any, newInputValue: any): void;

  onInputChange(event: any, newInputValue: string): void;
}

const PaiMultiInput: React.FC<Props> = ({ value, values, placeholder, label, disableBorder, onChange, onInputChange }) => {
  const { classes } = useStyles({ disableBorder });

  return (
    <div style={{ width: '100%' }}>
      {!_.isNil(label) ? <Typography className={classes.label}>{label}</Typography> : null}
      <Autocomplete
        className={classes.autoComplete}
        classes={{ input: classes.autoCompleteInput, paper: classes.paper }}
        ListboxProps={{ className: classes.listBox }}
        value={values}
        multiple={true}
        options={[]}
        inputValue={value}
        onChange={onChange}
        onInputChange={onInputChange}
        limitTags={1}
        renderTags={(value: string[], getTagProps) =>
          value.map((option: string, index: number) => (
            // eslint-disable-next-line react/jsx-key
            (<Chip variant="outlined" size={'small'} label={option} {...getTagProps({ index })} style={{ borderRadius: 0, background: '#FFF' }} />)
          ))
        }
        popupIcon={<ExpandMoreIcon />}
        renderInput={(params: any) => <TextField {...params} placeholder={placeholder} variant={'outlined'} fullWidth={true} />}
        freeSolo={true}
      />
    </div>
  );
};

const useStyles = makeStyles<{ disableBorder?: boolean }>()((theme, { disableBorder }) => ({
  fieldInput: {
    paddingLeft: '16px',
    paddingTop: '8.5px',
    paddingBottom: '8.5px',
    fontSize: theme.typography.pxToRem(13),
    '&::placeholder': {
      opacity: 1,
    },
    '&:focus': {
      borderRadius: 0,
    },
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 1000px #FFF inset',
      borderRadius: 0,
    },
  },
  autoComplete: {
    '& .MuiOutlinedInput-root': {
      padding: disableBorder ? 0 : '2.5px',
      background: theme.palette.backgrounds.main,
      borderRadius: 0,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: disableBorder ? 'none' : `1px solid ${theme.palette.primary.main}`,
        borderRadius: 0,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: disableBorder ? 'none' : `1px solid ${theme.palette.primary.main}`,
      borderRadius: 0,
    },
  },
  autoCompleteInput: {
    padding: '8.5px 12px !important',
    fontSize: theme.typography.pxToRem(13),
    background: disableBorder ? undefined : theme.palette.backgrounds.main,
    minHeight: 'calc(39px - 8px - 8px)',
    '&::placeholder': {
      opacity: 0.67,
      fontSize: theme.typography.pxToRem(11),
    },
  },
  listBox: {
    padding: 0,
  },
  paper: {
    borderRadius: 0,
  },
  listItem: {
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(13),
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    padding: '6px 16px',
    '&:last-of-type': {
      borderBottom: 'none',
    },
    '&.selected': {
      background: theme.palette.backgrounds.main,
      opacity: 1,
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
      opacity: 1,
    },
  },
  label: {
    marginBottom: '8px',
    fontSize: theme.typography.pxToRem(13),
    textDecoration: 'underline',
  },
}));

export default PaiMultiInput;
